import { __decorate } from "tslib";
import Component from "vue-class-component";
import ReactiveComponent from "../components/ReactiveComponent";
import Task from "@/services/task";
import TemplateContent from "@/components/template/TemplateContent.vue";
import UserForm from "@/components/UserForm.vue";
let InviteUser = class InviteUser extends ReactiveComponent {
    constructor() {
        super(...arguments);
        this.email = "";
        this.firstname = "";
        this.lastname = "";
        this.role = "member";
        this.boards = Array();
        this.optionExtraStrength = false;
        this.optionExtraGym = false;
        this.optionExtraAerobic = false;
        this.optionExtraDouble = false;
        this.submitTask = Task.idle();
    }
    submit() {
        const allUsersQuery = require("@/apollo/queries/allUsers.graphql");
        this.subscribeMutation({
            tag: "submit",
            options: {
                mutation: require("@/apollo/mutations/inviteUser.graphql"),
                variables: {
                    firstname: this.firstname,
                    lastname: this.lastname,
                    email: this.email.trim().toLowerCase(),
                    role: this.role,
                    optionExtraStrength: this.optionExtraStrength,
                    optionExtraGym: this.optionExtraGym,
                    optionExtraAerobic: this.optionExtraAerobic,
                    optionExtraDouble: this.optionExtraDouble,
                    boards: this.boards.map((it) => ({
                        board_id: it,
                    })),
                    boardId: this.boards[this.boards.length - 1],
                },
                update: (store, { data }) => {
                    try {
                        const allUsers = store.readQuery({
                            query: allUsersQuery,
                        });
                        allUsers.user.push(data.insert_user.returning[0]);
                        store.writeQuery({ query: allUsersQuery, data: allUsers });
                    }
                    catch (e) {
                        console.log("Failed to update cache after insert_user mutation");
                        console.log(e);
                    }
                },
            },
            onTask: (task) => {
                this.submitTask = task;
                if (task.isSuccessful) {
                    this.$router.push({ name: "users" });
                }
            },
        });
    }
};
InviteUser = __decorate([
    Component({
        components: { UserForm, TemplateContent },
    })
], InviteUser);
export default InviteUser;
